module.exports = "<div #subscriberDiv id=\"subscriberDiv\"></div>\t\n"